import React from 'react';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';

const SubcontractorManagementHome = () => {
  return (
    <main>
      <HelmetHelper
        title="Subcontractor Dashboard"
        description="Subcontractor Dashboard"
      />
      <h2>Subcontractor Dashboard</h2>
    </main>
  );
};

export default SubcontractorManagementHome;
